import { Card, Typography } from '@material-ui/core';
import React from 'react';
import { IBoreholeCalibration } from '../../../../@types/model/borehole/boreholeCalibration';
import OutlinedStadiumButton from '../../../customComponents/button/OutlinedStadiumButton';
import BoreholeCalibrationEntryNeighbourGraphView from './CalibrationEntryNeighbourGraphView';
import BoreholeCalibrationEntryNeighbourTableView from './CalibrationEntryNeighbourTableView';

interface IBoreholeCalibrationEntryNeighbourLogViewProps {
    calibration : IBoreholeCalibration;
    isLoading : boolean;
}

interface IBoreholeCalibrationEntryNeighbourLogViewState {
    viewAsTable : boolean;
}

export default class BoreholeCalibrationEntryNeighbourLogView extends React.Component<IBoreholeCalibrationEntryNeighbourLogViewProps, IBoreholeCalibrationEntryNeighbourLogViewState> {
    constructor(props : IBoreholeCalibrationEntryNeighbourLogViewProps) {
        super(props);
        this.state = {
            viewAsTable: false,
        };
    }

    private readonly onViewAsClick = () => {
        this.setState({
            viewAsTable: !this.state.viewAsTable,
        });
    };

    public readonly render = () => {
        const { calibration, isLoading } = this.props;
        const { viewAsTable } = this.state;
        return (
            <div className='fdc'>
                <Card className='fdr aic jcc p15 bcp'>
                    <Typography className='flx1 aic jcc fs18 fwb cw'>
                        NEIGHOURING BOREHOLES
                    </Typography>
                    <div className='posr'>
                        <div className='posa posr0 postn17 w150'>
                            <OutlinedStadiumButton
                                variant={'outlined'}
                                onClick={this.onViewAsClick}
                                className={'cw bocw'}
                            >
                                VIEW AS {viewAsTable ? 'GRAPH' : 'TABLE'}
                            </OutlinedStadiumButton>
                        </div>
                    </div>
                </Card>
                <div className='fdc mt16 pl20 pr20'>
                    <Card className='fdr aic jcfs p15 dvbg'>
                        <Typography className='aic jcc fs14 fw500 cw'>
                            LOG {!viewAsTable ? 'GRAPH' : 'TABLE'}
                        </Typography>
                    </Card>
                    {
                        !viewAsTable &&
                        <BoreholeCalibrationEntryNeighbourGraphView
                            calibration={calibration}
                            isLoading={isLoading}
                        />
                    }
                    {
                        viewAsTable &&
                        <BoreholeCalibrationEntryNeighbourTableView
                            calibration={calibration}
                            isLoading={isLoading}
                        />
                    }
                </div>
            </div>
        );
    };
}
